import apiClient from 'services/axios'
import apiFormDataClient from 'services/axios-formdata'

const BASE_URL = 'order/history'
const BASE_URL_1 = 'order/future_order'
const BASE_URL2 = 'order'

export async function getOrders(payload) {
  const { from, to } = payload.payload
  return apiClient
    .get(`${BASE_URL}?from=${from}&to=${to}`)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function getOrderDetails(payload) {
  return apiClient
    .get(`${BASE_URL2}/${payload.id}`)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function cancelOrder(id) {
  return apiFormDataClient
    .get(`${BASE_URL2}/${id}/cancel`)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function getFutureOrders(payload) {
  return apiClient
    .post(`${BASE_URL_1}`, payload)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function updateOrderAddress(orerId, payload) {
  return apiClient
    .post(`${BASE_URL2}/${orerId}/address`, payload)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function updateOrderTime(orerId, payload) {
  return apiClient
    .post(`${BASE_URL2}/${orerId}/date-time`, payload)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function cancelDelivery(id) {
  return apiFormDataClient
    .get(`${BASE_URL2}/${id}/cancel-driver`)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export async function createDelivery(id) {
  return apiFormDataClient
    .get(`${BASE_URL2}/${id}/create-driver`)
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}